// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var NetworkAnalyticsLogo = function NetworkAnalyticsLogo(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      opacity: ".5",
      d: "M8.23 1a40.67 40.67 0 016.06 2.73.32.32 0 01.19.27 15.13 15.13 0 01-1 6.1V4.62a.27.27 0 00-.16-.22 34.31 34.31 0 00-5.13-2.33H8A34.31 34.31 0 002.83 4.4a.27.27 0 00-.16.22 12 12 0 002 7.29v1.35C1.29 9.67 1.7 4.07 1.71 4a.32.32 0 01.19-.27A40.67 40.67 0 018 1a1.22 1.22 0 01.23 0z"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "5.14",
      y: "12.01",
      width: "2",
      height: "3",
      rx: ".5"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "8.14",
      y: "10.01",
      width: "2",
      height: "5",
      rx: ".5"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: "11.14",
      y: "8.01",
      width: "2",
      height: "7",
      rx: ".5"
    }))
  );
};

export default NetworkAnalyticsLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/NetworkAnalyticsLogo.js
// module id = 1032
// module chunks = 0